import Swiper from "swiper/bundle";

export default class ThumbnailCarousel {
  constructor(element, extraOptionsFirst, extraOptionsSecond) {
    this.element = element;
    this.extraOptionsFirst = extraOptionsFirst;
    this.extraOptionsSecond = extraOptionsSecond;

    this.swiperMainElement = this.element.querySelector(".js-carousel-main");
    this.swiperThumbnailElement = this.element.querySelector(".js-carousel-thumbs");
    this.swiperButtonPrev = this.element.querySelector(".swiper-button-prev");
    this.swiperButtonNext = this.element.querySelector(".swiper-button-next");
    this.swiperZoomContainers = this.element.querySelectorAll(".swiper-zoom-container");

    this.shouldZoom = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0; // incase of touch support we should not use mousemove zoom.

    this.initialize();
  }

  initialize() {
    if (this.element.classList.contains("landscape")) {
      this.extraOptionsSecond.slidesPerView = 3;
    }

    this.defaultOptions = {
      lazy: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
        },
        1024: {
          spaceBetween: 24,
        },
      },
    };

    this.thumbnailSwiper = new Swiper(this.swiperThumbnailElement, {
      ...this.defaultOptions,
      ...this.extraOptionsSecond,
    });

    this.mainSwiper = new Swiper(this.swiperMainElement, {
      zoom: {
        enabled: this.shouldZoom,
        toggle: false,
      },
      thumbs: {
        swiper: this.thumbnailSwiper,
      },
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      ...this.defaultOptions,
      ...this.extraOptionsFirst,
    });

    // Prevent accidental swipe on zoom.
    this.mainSwiper.on("zoomChange", (_, scale) => {
      this.mainSwiper.allowTouchMove = this.mainSwiper.allowSlideNext = this.mainSwiper.allowSlidePrev = scale <= 1;
    });

    this.swiperZoomContainers.forEach((container) => {
      const img = container.querySelector("img");

      container.addEventListener("mouseover", () => {
        if (this.mainSwiper.zoom.scale < 2) {
          this.mainSwiper.zoom.in();
        }
      });

      container.addEventListener("mousemove", (e) => {
        const x = e.clientX - container.getBoundingClientRect().left;
        const y = e.clientY - container.getBoundingClientRect().top;

        const xPercent = (x / container.offsetWidth) * 100;
        const yPercent = (y / container.offsetHeight) * 100;

        img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      });

      container.addEventListener("mouseout", () => {
        if (this.mainSwiper.zoom.scale > 1) {
          this.mainSwiper.zoom.out();
        }
      });
    });
  }
}
